import { DownArrowIcon, UpArrowIcon } from '@assets/icons';

import { ResponsiveNavDownButton } from '../DatePickerStyle';
import { renderNavButton } from '../renderNavButton';
import SingleDatePicker, {
  DayPickerSingleDateControllerProps,
} from './SingleDatePickerResponsive';

const ResponsiveSingleDatePicker = (
  props: DayPickerSingleDateControllerProps
) => {
  return (
    <SingleDatePicker
      orientation='verticalScrollable'
      numberOfMonths={12}
      renderNavPrevButton={renderNavButton(
        ResponsiveNavDownButton,
        UpArrowIcon,
        20
      )}
      renderNavNextButton={renderNavButton(
        ResponsiveNavDownButton,
        DownArrowIcon,
        20
      )}
      daySize={38}
      {...props}
    />
  );
};

export default ResponsiveSingleDatePicker;
